// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__TJ8Wt","textarea":"styles_textarea__2BhBw"};